import type { LinkProps } from 'react-router';

import { Link as ReactRouterLink } from 'react-router';

import { clsx } from '~/styles/utils';

import { linkStyle } from './Link.css';

type Props = LinkProps;

export const Link = ({ ...delegated }: Props) => {
  return <ReactRouterLink {...delegated} className={clsx(linkStyle, delegated.className)} />;
};
